import { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useProviderProductCode, { useRelations } from '@hooks/useProviderProductCode'
import useServiceProduct from '@hooks/useServiceProduct'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

const confirmDelete = (deleteProviderProductCode, deleteFn) => {
  const deleteProviderProductCodePayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Product Deleted',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, delete it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Delete Product Code?',
  }).then(({ value }) => {
    if (value){
      deleteProviderProductCode(deleteProviderProductCodePayload)
    }
  })
}

const ProviderProductCodeListItem = (props) => {
  const {
    providerProductCode,
  } = props
  const { product_code } = providerProductCode

  const pageContext = useContext(PageContext)
  const {
    callbacks,
  } = pageContext
  const { deleteProviderProductCode } = callbacks

  const {
    callbacks: {
      createOrEditProviderProductCode,
      deleteProviderProductCode: deleteFn,
    },
  } = useProviderProductCode(providerProductCode)

  const { serviceProduct } = useRelations(providerProductCode)
  const { title } = serviceProduct

  const {
    service: { title: serviceTitle },
    urls: { editServiceProductUrl },
  } = useServiceProduct(serviceProduct)

  const separator = product_code && serviceTitle ? '|' : ''

  return (
    <DashboardModuleListItem
      secondaryText={`${product_code} ${separator} ${serviceTitle}`}
      title={title}
    >
      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditProviderProductCode()}
          type="edit"
        />

        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => confirmDelete(deleteProviderProductCode, deleteFn)}
          type="delete"
        />

        <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
          <DashboardModuleListItem.Icon
            href={`${editServiceProductUrl}?redirect=${generateRedirectUrl()}`}
            type="link"
          />
        </ScopedConditionalContent>
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

ProviderProductCodeListItem.propTypes = {
  providerProductCode: PropTypes.object.isRequired,
}

export default ProviderProductCodeListItem
